import reducer from './reducers';
import * as firstAnalysesActions from './actions';
import * as firstAnalysesSelectors from './selectors';

export { firstAnalysesActions, firstAnalysesSelectors };
export default reducer;